import React, { useMemo, useState, useEffect } from "react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DivTag from "../../Components/DivComponent/DivTag";
import Button from "../../Components/ButtonComponent/Button";
import FormValidation from "../../Components/FormValidation/FormValidation";
import SelectWithLabelOption from "../../Components/SelectComponent/SelectWithLabelOption";
import TextAreaWithLabel from "../../Components/TextAreaWithLabel/TextAreaWithLabel";
import ReportHeading from "../../Components/ReportHeadings/ReportHeadings";
import InputWithLabel from "../../Components/InputComponent/InputWithLabel";
import Option from "../../Components/OptionComponent/Option";
import { motion } from "framer-motion";
import {
  addApiService,
  RetriveServicecategoryService,
  CreateServiceCategoryService,
  fetchVendorForAddingService,
} from "../../../services/apiaddservice";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import { retrivePackageService } from "../../../services/PackageList/PackageService";
import Seo from "../../../components/SeoComponent/Seo";
import Loader from "../../../components/Loader/Loader";
import UnifiedApiParameterBuilder from "./UnifiedApiParameterBuilder";
import { Info } from "lucide-react";

const AddService = () => {
  const initialState = {
    service: "",
    status: "",
  };
  const [value, setValue] = useState("");
  const [serviceCategoryList, setServiceCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [postUrl, setPostUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [requestResponse, setRequestResponse] = useState("");
  const [systemName, setSystemName] = useState("");
  const [preference, setPreference] = useState("");
  const [statusAdd, setStatusAdd] = useState("");
  const [successResponse, setSuccessResponse] = useState("");
  const [failedResponse, setFailedResponse] = useState("");
  const [activationFees, setActivationFees] = useState();
  const [isAgreementAgreed, setIsAgreementAgreed] = useState(false);
  const [adjustmentType, setAdjustmentType] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [vendorId, setVendorId] = useState("");
  const [perHitCost, setPerHitCost] = useState("");
  const [keyDescription, setKeyDescription] = useState("");
  const [serviceValue, setServiceValue] = useState("");
  const [method, setMethod] = useState("");
  const [newCategoryName, setNewCategoryName] = useState("");
  const [packageData, setPackageData] = useState([]);
  const [statusCode, setStatusCode] = useState("");

  const validate = (values) => {
    let errors = {};

    if (!values.SelectService || values.SelectService === "") {
      errors.SelectService = "Service is required";
    }
    if (!values.SelectStatus || values.SelectStatus === "") {
      errors.SelectStatus = "Status is required";
    }
    return errors;
  };
  const { errors, handleBlur } = FormValidation(initialState, validate);

  useEffect(() => {
    const loadVendors = async () => {
      try {
        const res = await fetchVendorForAddingService();

        const list = res?.data?.vendors || res?.data?.data || res?.data || [];

        setVendorList(Array.isArray(list) ? list : []);
      } catch (error) {
        console.error("Vendor fetch failed:", error);
        setVendorList([]);
      }
    };

    loadVendors();
  }, []);

  const modules_quill = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      [{ color: ["#ff0000", "#00ff00", "#0000ff", "#000000"] }],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
  ];

  const resetForm = () => {
    setActivationFees("");
    setFailedResponse("");
    setValue("");
    setServiceName("");
    setRequestResponse("");
    setPostUrl("");
    setPreference("");
    setStatusAdd("");
    setVendorId("");
    setKeyDescription("");
    setServiceValue("");
    setMethod("");
    setSuccessResponse("");
    setSystemName("");
    setAdjustmentType("");
    setIsAgreementAgreed(false);
    setSelectedCategory("");
    setPerHitCost("");
  };

  const handleSubmitSerice = async () => {
    setIsLoading(true);
    try {
      if (isAgreementAgreed === false) {
        return showErrorToast("Checked Agrement ");
      }
      if (selectedCategory === "") {
        showErrorToast("Category is required ");
        return;
      }
      if (serviceName === "") {
        showErrorToast("service name  is required ");
        return;
      }
      if (postUrl === "") {
        showErrorToast("Post url is required ");
        return;
      }
      if (method === "") {
        showErrorToast("method is requirerd");
        return;
      }
      if (value === "") {
        showErrorToast("Introduction  is required ");
        return;
      }
      if (requestResponse === "") {
        showErrorToast("Request Response is required ");
        return;
      }
      if (failedResponse === "") {
        showErrorToast("Failed Response is required ");
        return;
      }
      if (systemName === "") {
        showErrorToast("System Name is required");
        return;
      }
      if (activationFees === "") {
        showErrorToast("Activation  fees is required ");
        return;
      }
      const response = await addApiService({
        skip_status_codes: statusCode?.toString().split(","),
        categoryId: selectedCategory,
        serviceName: serviceName,
        postUrl: postUrl,
        introduction: value,
        requestResponse: requestResponse,
        failedResponse: failedResponse,
        fees: activationFees,
        adjustment_type: adjustmentType,
        successResponse: successResponse,
        system_name: systemName,
        preference: preference,
        status_id: statusAdd,
        vendor_id: vendorId,
        key_description: keyDescription || "",
        service_value: serviceValue,
        method: method,
        per_hit_cost: perHitCost,
      });

      console.log(response);

      if (response.status.code === 201) {
        showSuccessToast(response.message || "Successfully added service ");
        resetForm();

        // setActivationFees('')
        // setFailedResponse('');
        // setValue('');
        // setServiceName('');
        // setRequestResponse('');
        // setPostUrl('');
        // setPreference('');
        // setStatusAdd('');
        // setVendorId(null);
        // setVendorList('');
        // setKeyDescription('');
        // setServiceValue('');
        // setMethod('');
        // setSuccessResponse('');
        // setSystemName('');
        // setAdjustmentType('');
        // setIsAgreementAgreed('');
        // setServiceCategoryList('');
        // setSelectedCategory('');
        // setPackageData('');
        // setPerHitCost('');

        return;
      }
      if (response.status === 422) {
        showErrorToast("post url already exits");
        return;
      }
    } catch (error) {
      showErrorToast("Failed to add new service ");
      setIsLoading(false);
      return;
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateCategory = async () => {
    if (!newCategoryName.trim()) {
      showErrorToast("Category name required");
      return;
    }
    setIsLoading(true);
    try {
      const response = await CreateServiceCategoryService({
        serviceName: newCategoryName,
      });
      // CHECK THE RESPONSE STRUCTURE PROPERLY
      if (response?.success) {
        showSuccessToast(
          "Success",
          response.message || "Category created successfully!",
        );
        await RetriveServicecategory();
        setNewCategoryName("");
        // setIsOpen(false);
      } else {
        showErrorToast(response?.message || "Unable to create category");
      }
    } catch (error) {
      console.log(error);
      showErrorToast("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  async function RetriveServicecategory() {
    setIsLoading(true);
    try {
      const response = await RetriveServicecategoryService();

      if (response.success === true) {
        const list =
          response.data?.data || // API format: {data: {data: []}}
          response.data || // API format: {data: []}
          [];

        setServiceCategoryList(list); // MUST be an array
      }
    } catch (error) {
      console.log(error);
      showErrorToast("Failed to load categories");
    } finally {
      setIsLoading(false);
    }
  }

  async function RetrivePackageData() {
    setIsLoading(true);
    try {
      const response = await retrivePackageService();
      console.log(response);
      setPackageData(response.data);
    } catch (error) {
      setIsLoading(false);
      return error;
    } finally {
      setIsLoading(false);
    }
  }

  useMemo(() => {
    RetriveServicecategory();
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2 }}
    >
      <Seo />
      {isLoading && <Loader />}
      <DivTag
        id=""
        className=" border-2 border-solid border-blue-800 rounded-xl border-t-0 mt-12 bg-white"
      >
        <div className="flex items-center justify-between w-full mb-3">
          {/* CENTERED HEADING */}
          <div className="flex-1 text-center">
            <ReportHeading name="Add Service" />
          </div>

          {/* BUTTON ON RIGHT */}
          <button
            onClick={() => setIsOpen(true)}
            className="bg-blue-700 text-white px-2 me-5 py-1 rounded"
          >
            Category Master
            <span className="text-red-600 animate-scrollUp text-xs font-bold mt-1 ms-1">
              New
            </span>
          </button>
        </div>

        {isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white p-3 rounded-lg shadow-xl w-[40rem] h-[28rem] relative">
              {/* HEADER ROW */}
              <div className="flex justify-between items-center mb-1 border-b pb-2">
                <h2 className="font-bold text-lg">Create Service Category</h2>

                <button
                  onClick={() => setIsOpen(false)}
                  className="px-1 py-0 bg-red-600 text-white rounded hover:bg-gray-400"
                >
                  Close
                </button>
              </div>

              {/* INPUT FIELD */}
              <input
                type="text"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                placeholder="Enter category name"
                className="border w-full px-3 py-2 rounded mb-2 border-blue-500"
              />

              <div className="flex justify-center gap-2 mb-2">
                <button
                  onClick={handleCreateCategory}
                  className="px-2 py-1 bg-blue-700 text-white rounded hover:bg-blue-800"
                >
                  Save
                </button>
              </div>

              {/* LIST */}
              <div className="max-h-[14rem] overflow-y-auto border rounded p-2 mb-1">
                <h3 className="font-semibold text-sm mb-2">
                  Existing Categories:
                </h3>

                {serviceCategoryList.length > 0 ? (
                  serviceCategoryList.map((c) => (
                    <div key={c.id} className="text-sm border-b py-2">
                      {c.name}
                    </div>
                  ))
                ) : (
                  <p className="text-xs text-gray-500">No categories found</p>
                )}
              </div>
            </div>
          </div>
        )}

        <DivTag className="flex flex-wrap p-2 mt-2">
          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Select Service Category"
            id="service"
            name="service"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className={
              errors.service
                ? "border border-red-500"
                : "border border-blue-600"
            }
            error={errors.service}
            required={true}
          >
            <Option value="" disabled selected>
              Select Service Category
            </Option>
            {serviceCategoryList && serviceCategoryList.length > 0
              ? serviceCategoryList.map((category, index) => (
                  <Option key={index} value={category.id}>
                    {category?.name}
                  </Option>
                ))
              : ""}
          </SelectWithLabelOption>

          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4 px-1 md:mb-0"
            label="Select Adjustment_type"
            id="service"
            name="service"
            value={adjustmentType}
            onChange={(e) => setAdjustmentType(e.target.value)}
            required={true}
          >
            <Option value="" disabled selected>
              Select adjustment_type
            </Option>
            <Option value="charge">charge</Option>
            <Option value="commission">commission</Option>
            <Option value="charge_slab">Charge Slab</Option>
          </SelectWithLabelOption>
          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-2 md:mb-0 text-left mb-0 text-black"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md"
            label="Service Name"
            type="text"
            name="service_name"
            placeholder="Enter Service Name..."
            id="service_name"
            value={serviceName}
            onChange={(e) => setServiceName(e.target.value)}
            className="border"
            required={true}
          />

          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-2 md:mb-0 text-left mb-0 text-black"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md"
            label="System Name"
            type="text"
            name="system_name"
            placeholder="Enter System Name..."
            id="system_name"
            value={systemName}
            onChange={(e) => setSystemName(e.target.value)}
            className="border"
            required={true}
          />

          <InputWithLabel
            DivclassName="w-full md:w-1/4 text-black px-2 md:mb-0 text-left mb-0 text-black"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md text-black"
            label="Post URL"
            type="url"
            name="post_url"
            placeholder="Enter POST URL..."
            id="post_url"
            value={postUrl}
            onChange={(e) => setPostUrl(e.target.value)}
            className="border"
            required={true}
          />

          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Preference"
            id="preference"
            name="preference"
            value={preference}
            onChange={(e) => setPreference(e.target.value)}
            className={
              errors.preference
                ? "border border-red-500"
                : "border border-blue-600"
            }
            error={errors.preference}
            required={true}
          >
            <Option value="" disabled selected>
              Select Preference
            </Option>
            <Option className="bg-red-500 text-white" value="None">
              None
            </Option>
            <Option className=" bg-green-400 text-white" value="Recommended">
              Recommended
            </Option>
            <Option
              className="bg-green-700 text-white"
              value="Highly Recommended"
            >
              Highly Recommended
            </Option>
          </SelectWithLabelOption>

          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Status"
            id="status"
            name="status"
            value={statusAdd}
            required={true}
            onChange={(e) => setStatusAdd(Number(e.target.value))}
            className={
              errors.status ? "border border-red-500" : "border border-blue-600"
            }
            error={errors.status}
          >
            <Option value="" disabled>
              Select Status
            </Option>
            <Option value={5} className="bg-green-600 text-white">
              Active
            </Option>
            <Option value={4} className="bg-yellow-500 text-white">
              Inactive
            </Option>
            <Option value={18} className="bg-red-500 text-white">
              Deprecated
            </Option>
            <Option value={19} className="bg-blue-500 text-white">
              CommingSoon
            </Option>
          </SelectWithLabelOption>

          {/* <InputWithLabel DivclassName="w-full md:w-1/4 px-2 md:mb-0 text-left mb-0 text-black"
                        DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md" label="Source Details" type="text" name="source_details" placeholder="Enter Source Details..." id="source_details" value={adjustmentType} onChange={(e) => setAdjustmentType(e.target.value)} className="border" required={false} /> */}

          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Vendor"
            id="vendor_id"
            name="vendor_id"
            value={vendorId}
            onChange={(e) => setVendorId(Number(e.target.value))}
            className={
              errors.vendor_id
                ? "border border-red-500"
                : "border border-blue-600"
            }
            error={errors.vendor_id}
          >
            <Option value="" disabled>
              Select Vendor
            </Option>

            {Array.isArray(vendorList) &&
              vendorList.map((v) => (
                <Option key={v.id} value={v.id}>
                  {v.name}
                </Option>
              ))}
          </SelectWithLabelOption>

          <div className="w-full mt-2 mb-2">
            <div className="grid grid-cols-2 gap-4">
              {/* <TextAreaWithLabel DivclassName="w-full px-0 md:mb-0 text-left mb-0 text-black"
              label="Key Description"
              type="text"
              placeholder="Enter Key Description"
              value={keyDescription}
              onChange={(e) => setKeyDescription(e.target.value)}
              class_name='h-12'
          /> */}

              <UnifiedApiParameterBuilder
                label="API Configuration"
                value={keyDescription || ""}
                onChange={(jsonString) => setKeyDescription(jsonString)}
              />

              <div className="">
                <TextAreaWithLabel
                  DivclassName="w-full px-2 md:mb-0 text-left mb-0 text-black"
                  label="Service Value"
                  type="text"
                  placeholder="Enter Service Value"
                  value={serviceValue}
                  onChange={(e) => setServiceValue(e.target.value)}
                  class_name="h-12"
                />
                <div>
                  <SelectWithLabelOption
                    DivclassName="w-1/2 px-3 md:mb-0"
                    label="Method"
                    id="method"
                    name="method"
                    value={method}
                    onChange={(e) => setMethod(e.target.value)}
                    className="border border-blue-600"
                    error={errors.method}
                    required={true}
                  >
                    <Option value="" disabled className="text-gray-400">
                      Select method
                    </Option>

                    <Option value="GET" className="text-green-400 text-bold">
                      GET
                    </Option>
                    <Option value="POST" className="text-orange-400 text-bold">
                      POST
                    </Option>
                    <Option value="PUT" className="text-blue-400 text-bold">
                      PUT
                    </Option>
                    <Option value="PATCH" className="text-purple-400 text-bold">
                      PATCH
                    </Option>
                    <Option value="DELETE" className="text-red-400 text-bold">
                      DELETE
                    </Option>
                    <Option value="HEAD" className="text-lime-400 text-bold">
                      HEAD
                    </Option>
                    <Option value="OPTIONS" className="text-pink-400 text-bold">
                      OPTIONS
                    </Option>
                  </SelectWithLabelOption>

                  <InputWithLabel
                    DivclassName="w-full md:w-1/5 text-black px-2 md:mb-0 text-left mb-0 text-black"
                    DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md text-black"
                    label="Per Hit Cost"
                    type="perHitCost"
                    name="perHitCost"
                    placeholder="Enter Per Hit Cost..."
                    id="perHitCost"
                    value={perHitCost}
                    onChange={(e) => setPerHitCost(e.target.value)}
                    className="border"
                    required={false}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex w-full">
            <div className="flex flex-col w-full">
              <label className="block uppercase tracking-wide text-xs font-bold">
                Instruction <span className="text-red-500">*</span>
              </label>
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                modules={modules_quill}
                formats={formats}
                placeholder="Enter Instruction here...."
                required={true}
                className="w-full h-32"
              />
            </div>
            <div className="flex gap-1 mt-12">
              <TextAreaWithLabel
                DivclassName="w-full px-0 md:mb-0 text-left mb-0 text-black"
                label="Request"
                type="text"
                placeholder="Enter Request Sample"
                name="req_sample"
                id="req_sample"
                value={requestResponse}
                onChange={(e) => setRequestResponse(e.target.value)}
                onBlur={handleBlur}
                class_name="h-72"
              />
              <TextAreaWithLabel
                DivclassName="w-full px-2 md:mb-0 text-left mb-0 text-black"
                label="Sucess Response"
                type="text"
                placeholder="Enter Request Sample"
                name="req_sample"
                id="req_sample"
                value={successResponse}
                onChange={(e) => setSuccessResponse(e.target.value)}
                onBlur={handleBlur}
                class_name="h-72"
              />

              <TextAreaWithLabel
                DivclassName="w-full px-2 md:mb-0 text-left mb-0 text-black"
                label="failed Response"
                type="text"
                placeholder="Failed Response"
                name="successResponse"
                id="successResponse"
                value={failedResponse}
                onChange={(e) => setFailedResponse(e.target.value)}
                class_name="h-72"
              />
            </div>
          </div>

          <InputWithLabel
            DivclassName="w-full md:w-1/3 px-2 md:mb-0 text-left mb-0 text-black"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 handleSearcherbg-white border rounded shadow-md"
            label="Service Price"
            type="number"
            name="post_url"
            placeholder="Enter Price "
            id="post_url"
            value={activationFees}
            onChange={(e) => setActivationFees(e.target.value)}
            className="border"
            required={true}
          />

          <div className="flex mt-5 ml-6 items-center gap-2 ">
            <input
              type="checkbox"
              className="h-5 w-5"
              onChange={() => setIsAgreementAgreed(!isAgreementAgreed)}
            />
            <p className="text-neutral-500 ">I have agreed terms & condition</p>
          </div>

          <Button
            type="submit"
            className="text-center ms-4 text-white bg-blue-700 shadow-lg bg-gradient-to-r mt-3 from-blue-900 via-teal-400
           to-purple-900 font-semibold rounded-md px-1 py-0 text-lg hover:bg-red-300"
            onClick={handleSubmitSerice}
          >
            Submit
          </Button>
        </DivTag>
      </DivTag>
      <ToastContainer />
    </motion.div>
  );
};

export default AddService;
